import React from 'react';

const TermsConditions = () => {
    return (
        <div className="terms-conditions-page">
            <section className="terms-content-section">
                <div className="container" style={{ maxWidth: '900px', margin: '0 auto', padding: '3rem 1.5rem' }}>
                    <h1 style={{
                        color: '#069668',
                        fontSize: '2.5rem',
                        marginBottom: '5rem',
                        textAlign: 'center'
                    }}>Terms & Conditions</h1>
                    <div className="terms-last-updated" style={{ marginBottom: '2rem', color: '#666' }}>
                        <p><strong>Last Updated:</strong> January 3, 2026</p>
                    </div>

                    <div className="terms-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>1. Acceptance of Terms</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            By accessing and using Yathartha's services, you accept and agree to be bound by the terms and provisions of this agreement.
                            If you do not agree to these terms, please do not use our services.
                        </p>
                    </div>

                    <div className="terms-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>2. Services Description</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            Yathartha provides financial advisory services including financial diagnosis, clarity reports, personal roadmaps,
                            and ongoing guidance. Our services are designed to help you understand your financial reality and make informed decisions.
                        </p>
                    </div>

                    <div className="terms-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>3. User Responsibilities</h2>
                        <p style={{ lineHeight: '1.8', color: '#333', marginBottom: '1rem' }}>
                            As a user of our services, you agree to:
                        </p>
                        <ul style={{ lineHeight: '1.8', color: '#333', paddingLeft: '2rem' }}>
                            <li>Provide accurate and complete information</li>
                            <li>Maintain the confidentiality of your account credentials</li>
                            <li>Use our services only for lawful purposes</li>
                            <li>Not misuse or attempt to gain unauthorized access to our systems</li>
                            <li>Respect intellectual property rights</li>
                        </ul>
                    </div>

                    <div className="terms-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>4. Financial Advice Disclaimer</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            While we strive to provide accurate and helpful financial guidance, our services do not constitute professional financial advice.
                            We recommend consulting with qualified financial professionals before making significant financial decisions. Yathartha is not
                            liable for any financial losses resulting from decisions made based on our services.
                        </p>
                    </div>

                    <div className="terms-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>5. No Product Sales or Commissions</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            Yathartha does not sell financial products and does not earn commissions from product recommendations. Our focus is solely
                            on providing clarity and guidance to help you make informed financial decisions.
                        </p>
                    </div>

                    <div className="terms-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>6. Intellectual Property</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            All content, materials, and intellectual property on our platform, including but not limited to text, graphics, logos,
                            and software, are the property of Yathartha and are protected by copyright and other intellectual property laws.
                        </p>
                    </div>

                    <div className="terms-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>7. Limitation of Liability</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            Yathartha shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from
                            your use of our services. Our total liability shall not exceed the amount you paid for our services in the past 12 months.
                        </p>
                    </div>

                    <div className="terms-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>8. Termination</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            We reserve the right to terminate or suspend your access to our services at any time, without prior notice, for conduct
                            that we believe violates these terms or is harmful to other users, us, or third parties.
                        </p>
                    </div>

                    <div className="terms-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>9. Modifications to Terms</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            We may modify these terms at any time. We will notify users of any material changes by posting the updated terms on our
                            website and updating the "Last Updated" date. Your continued use of our services after such modifications constitutes
                            acceptance of the updated terms.
                        </p>
                    </div>

                    <div className="terms-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>10. Governing Law</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            These terms shall be governed by and construed in accordance with the laws of India. Any disputes arising from these
                            terms or our services shall be subject to the exclusive jurisdiction of the courts in [Your City], India.
                        </p>
                    </div>

                    <div className="terms-section" style={{ marginBottom: '2.5rem' }}>
                        <h2 style={{ color: '#069668', marginBottom: '1rem', fontSize: '1.75rem' }}>11. Contact Information</h2>
                        <p style={{ lineHeight: '1.8', color: '#333' }}>
                            If you have any questions about these Terms & Conditions, please contact us at:
                        </p>
                        <p style={{ lineHeight: '1.8', color: '#333', marginTop: '1rem' }}>
                            <strong>Email:</strong> legal@yathartha.com<br />
                            <strong>Phone:</strong> +91 1234567890
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TermsConditions;
